import React from "react";
import swapIcon from "../../assets/icons/swap.svg";

export const SwapButton: React.FC = () => (
  <div className="flex justify-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
    <button
      type="button"
      className="w-10 md:w-12 h-10 md:h-12 bg-white cursor-default rounded-full border border-gray-200 flex items-center justify-center transition-colors shadow-sm"
    >
      <img src={swapIcon} alt="swap" className="w-3 h-3" />
    </button>
  </div>
);
